import React from 'react';
import FilterSlider from 'src/components/Filters/components/FilterSlider';
import { i18n } from '@lt/localization';
import type { FilterSliderProps } from 'src/components/Filters/components/FilterSlider/types';

const FilterBackwardDepartureTime = (props: FilterSliderProps): JSX.Element => (
  <FilterSlider {...props} Filter={FilterBackwardDepartureTime} />
);

FilterBackwardDepartureTime.filterName = 'backward_departure_time';
FilterBackwardDepartureTime.filterLabel = i18n.t(
  'checkout.filter.backwardDepartureTime.title',
);

export default FilterBackwardDepartureTime;
